const Register_img ={
    registerimg :"/Images/Register_img/Register_img.png"
}
export default Register_img;